import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type {
    ProviderId} from "@@/shared/providers/provider-id";
import {
    providerIdZodSchema,
} from "@@/shared/providers/provider-id";
import { storageItemIdZodSchema } from "@@/shared/storage-items/storage-item-id";
import { uploadIdZodSchema } from "@@/shared/upload-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { storageItemContentTypes } from "../content-types";
import type { Byte } from "../file-size-types";

const createSignedUploadUrlCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("CREATE_SIGNED_UPLOAD_URL_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    providerId: providerIdZodSchema.optional(),
    storageItemId: storageItemIdZodSchema,
    filesize: z.number().int().min(0) as unknown as z.ZodSchema<Byte>,
    originalFilename: z.string(),
    contentType: z.enum(storageItemContentTypes),
    uploadId: uploadIdZodSchema,
});

type CreateSignedUploadUrlCommand = z.infer<
    typeof createSignedUploadUrlCommandZodObject
>;
const createSignedUploadUrlCommandZodSchema: z.ZodSchema<CreateSignedUploadUrlCommand> =
    createSignedUploadUrlCommandZodObject;

type FactoryParams = Except<
    CreateSignedUploadUrlCommand,
    "_id" | "_type" | "_createdAt" | "providerId"
> & { providerId: ProviderId | undefined };
const createSignedUploadUrlCommandFactory = (params: FactoryParams) => {
    const createSignedUploadUrlCommand: CreateSignedUploadUrlCommand = {
        ...params,
        _id: generateId({ prefix: "create_signed_upload_url_command__" }),
        _type: "CREATE_SIGNED_UPLOAD_URL_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return createSignedUploadUrlCommand;
};

export {
    createSignedUploadUrlCommandFactory,
    createSignedUploadUrlCommandZodObject,
    createSignedUploadUrlCommandZodSchema,
};
export type { CreateSignedUploadUrlCommand };
